import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';
import { Newsletter } from '../../components';
import './Footer.css';
import zeroxadt_logo from "../../assets/ZeroxaDT_ICON_bg_transparent.png" //Structured data for locations and working hours
import tanainent_logo from "../../assets/TanAinent_icon_compresse.png" //Structured data for locations and working hours
const locations = [
  {
    name: 'Vauxhall Bridge Rd',
    address: '326 Vauxhall Bridge Rd, London SW1V 1AA',
    hours: [
      { days: 'Monday-Friday', time: '11:00 AM - 01:00 AM' },
      { days: 'Sunday', time: '11:00 AM - 11:00 PM' },
    ],
  },
  // {
  //   name: 'Haymarket',
  //   address: '33 Haymarket, London SW1Y 4HA',
  //   hours: [
  //     { days: 'Sunday-Thursday', time: '11:00 AM - 11:00 PM' },
  //     { days: 'Friday-Saturday', time: '11:00 AM - 02:00 AM' },
  //   ],
  // },
  {
    name: 'Camden High St',
    address: '19 Camden High St, London NW1 7JE in Camden Town',
    hours: [
      { days: 'Monday-Sunday', time: '10:00 AM - 12:00 AM' },
    ],
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer aria-labelledby="footer-heading">
      <div className="footer">
        <Newsletter /> {/* Social media section restored */}

        <div className="footer__links">
          {/* Locations Section */}
          <div className="footer__links_locations" role="region" aria-label="Our Locations">
            <h2 className="app__footer-headtext footer__heading" id="footer-locations-heading">
              Our Locations
            </h2>
            <ol className="footer__locations_list">
              {locations.map((location, index) => (
                <li key={index} className="location-item">
                  <div className="location-item__header">
                    <span className="location-item__icon" aria-hidden="true">📍</span>
                    <p className="p__opensans location-item__address">{location.address}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          {/* Logo Section */}
          <div className="footer__links_logo" role="region" aria-label="Brand Information">
            <h2 className="app__footer-headtext footer__heading" id="footer-logo-heading">
              Wok & Fire
            </h2>
            <p className="p__opensans footer__quote">
              "The best way to find yourself is to lose yourself in the service of others."
            </p>
          </div>

          {/* Working Hours Section */}
          <div className="footer__links_work" role="region" aria-label="Working Hours">
            <h2 className="app__footer-headtext footer__heading" id="footer-work-heading">
              Working Hours
            </h2>
            <ol className="footer__hours_list">
              {locations.map((location, index) => (
                <li key={index} className="location-item">
                  <div className="location-item__header">
                    <span className="location-item__icon" aria-hidden="true">🕒</span>
                    <p className="p__opensans location-item__name">{location.name}</p>
                  </div>
                  <ul className="location-hours">
                    {location.hours.map((hour, idx) => (
                      <li key={idx} className="p__opensans location-hours__item">
                        {hour.days}: {hour.time}
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ol>
          </div>
        </div>
        <div className="footer__copyright">

          <a href="/" className="footer__copyright_link">
            <p className="font_family">{currentYear} © Wok & Fire. All Rights Reserved.</p>
          </a>
          <hr className='mt-10'/>
          <p className="font_family mt-4 text-center text-sm text-gray-600">
            Built by

            <span className="inline-flex items-center gap-2 ml-2">

              <a
                href="https://zeroxadt.com/"
                className="inline-flex items-center gap-2 px-2 py-1 rounded-full bg-gray-100 hover:bg-gray-200 transition"
              >
                <img
                  src={zeroxadt_logo}
                  className="w-8 h-8 rounded-full"
                  alt='ZeroxaDT'
                />
                <span className="font-medium">ZeroxaDT</span>
              </a>

              <span className="text-gray-400">and</span>

              <a
                href="https://tanainentglobalukltd.com/"
                className="inline-flex items-center gap-2 px-2 py-1 rounded-full bg-gray-100 hover:bg-gray-200 transition"
              >
                <img
                  src={tanainent_logo}
                  alt="TanAinent Global UK Ltd"
                  className="w-8 h-8 rounded-full"
                />
                <span className="font-medium">TanAinent Global UK Ltd</span>
              </a>

            </span>
          </p>


        </div>
      </div>
    </footer>
  );
};

export default Footer;